import { render, staticRenderFns } from "./lossReporting.vue?vue&type=template&id=15e24481"
import script from "./lossReporting.vue?vue&type=script&lang=ts"
export * from "./lossReporting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports